import * as React from 'react';
import './loading.css';
import spinner from '../../../../assets/lottie/spinner.svg';

interface IIntermediateGlobalLoading {

}
export const IntermediateGlobalLoading: React.FC<IIntermediateGlobalLoading> = props => {
    return (
        <div className="whiteRow">
            <div className="container">
                <div className="page-splash"></div>
                <div className="page-splash-message">
                    BEE123 loading...
                    <br />
                    <br />
                    <img src={spinner} />
                </div>
            </div>
        </div>
    );
}